import { takeEvery, takeLatest, put, select } from 'redux-saga/effects';

import { 
  getLastSyncDate, 
  getCategoryGroupLists, 
} from 'companion-app-components/flux/category-group-lists/categoryGroupListsSelectors';
import { 
  getCategoryGroupListsAction, 
  getCategoryGroupListsSuccessAction, 
} from 'companion-app-components/flux/category-group-lists/categoryGroupListsActions';
import { resourceStoreTypes, resourceSagaUtils } from 'companion-app-components/flux/core';
import { authSelectors } from 'companion-app-components/flux/auth';

import * as actions from 'data/categoryGroupLists/categoryGroupListsActions';

const mkResourceConfig = (props) => resourceStoreTypes.mkQcsSyncResourceConfig({
  resourceName: 'categoryGroupLists',
  resourceBaseUrl: '/category-group-lists',
  getLastSyncDate,
  ...props,
});

export function* createCategoryGroupListsActionWater() {
  const config = mkResourceConfig({
    successAction: actions.createCategoryGroupListsSuccessAction,
    failureAction: actions.createCategoryGroupListsFailureAction,
  });
  yield takeEvery(actions.createCategoryGroupListsAction.type, resourceSagaUtils.qcsSyncCreateResource, config);
}

function* createCategoryGroupLists({ payload }) {
  const categoryGroupListsFetched = yield select(getCategoryGroupLists);
  const isWebFirstDataset = yield select(authSelectors.getIsWebfirstDataset);
  if (categoryGroupListsFetched.size === 0 && isWebFirstDataset) {
    if (payload.resources.length === 0) {
      const actionPayload = {
        description: 'Default list of all categories',
        isNotEditable: true,
        name: 'Full List',
      };
      yield put(actions.createCategoryGroupListsAction(actionPayload));
    }
  }
}

export function* getCategoryGroupListsSuccessActionWatcher() {
  yield takeLatest(getCategoryGroupListsSuccessAction, createCategoryGroupLists);
}

function* triggerGetCategoryGroupLists() {
  yield put(getCategoryGroupListsAction());
}

export function* createCategoryGroupListsSuccessActionWatcher() {
  yield takeEvery(actions.createCategoryGroupListsSuccessAction, triggerGetCategoryGroupLists);
}

export default [
  createCategoryGroupListsActionWater, 
  getCategoryGroupListsSuccessActionWatcher,
  createCategoryGroupListsSuccessActionWatcher,
];
